// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"mX-z","sponsoredTooltipWrapper":"nX-z","sponsoredTooltip":"oX-z","newCard":"pX-z"};